module.exports = __webpack_public_path__ + "media/images/lp_mb-bg3-8b13497f6a867df41be245aecf7f7731.png";